import { createContext } from 'react';

export var IconContext = createContext({
  prefixCls: 'arco',
});
